// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Nszx8","backdrop":"modal_backdrop__hpFL1","content":"modal_content__nrtR0","modalHeader":"modal_modalHeader__RGTbx"};